module.exports = __webpack_public_path__ + "static/img/select-img5.22a2543.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/select-img5.png
// module id = KUPP
// module chunks = 1